export const ItemType = 1;
export const PackageType = 2;

export const InventoryTypesLabel = {
  [ItemType]: 'Item',
  [PackageType]: 'Package'
};
